import imageOne from '@/assets/images/cities/guelph1.jpg'
import imageTwo from '@/assets/images/cities/guelph2.jpg'
import imageThree from '@/assets/images/cities/guelph3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Guelph',
  writeup: '',
  website: 'GuelphNotaryPublic.com',
  url: 'https://www.guelphnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(226) 314-0711',
      hours: {
        monday: '',
        tuesday: '',
        wednesday: ' 10:00AM to 4:30PM',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: ''
      },
      address: 'Carden Street Location',
      notes: 'No Power of Attorneys.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/guelph.js